(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[28967],{

/***/ 77472:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/phongvu/desktop/products/[sku]",
      function () {
        return __webpack_require__(548414);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 548414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var tenants_phongvu_desktop_products_sku___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(945656);
// AUTO GENERATED FILE. DO NOT EDIT.

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (tenants_phongvu_desktop_products_sku___WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41305,19303,90400,29078,4545,66756,3377,88837,22859,60085,18897,6174,55530,93712,49774,92888,40179], function() { return __webpack_exec__(77472); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);